import { TabsContent } from '@/components/common/tabs'
import { ErrorIcon } from '@/components/icons/error'
import type { TransactionsContext } from '@/queries/transactionsContext.query'
import type { StepName } from '@/types/transactionsContext'
import type { Vault } from '@/types/vault'

interface NotEligibleNoticeProps {
  value: StepName
}

export const NotEligibleNotice = ({ value }: NotEligibleNoticeProps) => (
  <TabsContent value={value} className="mt-3 md:mt-4">
    <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border bg-surface p-4 text-center">
      <ErrorIcon size={48} className="text-destructive" />
      <p className="font-medium text-heading-foreground text-xl">
        You are not eligible
        <br />
        to interact with this vault
      </p>
      <p className="text-sm">
        Please contact support at{' '}
        <a href="https://syrup.fi/lend" target="_blank" className="text-accent hocus:underline" rel="noreferrer">
          syrup.fi
        </a>{' '}
        for more information.
      </p>
    </div>
  </TabsContent>
)

export const isSyrupNotEligible = (vault: Vault, transactionsContext: TransactionsContext | null | undefined) =>
  vault.protocol.name === 'syrup' &&
  !(transactionsContext?.vaultSpecificData as Record<string, any> | undefined)?.['eligible']
